import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noValueTextExperiment: {
		id: 'issue-field-original-estimate-readview-full.original-estimate.no-value-text-experiment',
		defaultMessage: 'Add estimate',
		description: 'Message when the field has no value',
	},
});
